import{j as n}from"./chunk-GEPA7FLG.js";n();var o=`.dapp-core-component__ActionOrConnect__exrond-connect-btn {
  font-style: normal;
  font-family: Montserrat;
  font-weight: 400;
  padding: 10px 24px;
  background-color: #3066ff;
  border-radius: 8px;
}
.dapp-core-component__ActionOrConnect__exrond-connect-btn.dapp-core-component__ActionOrConnect__active {
  background-color: #153695;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(o));var r={"exrond-connect-btn":"dapp-core-component__ActionOrConnect__exrond-connect-btn",exrondConnectBtn:"dapp-core-component__ActionOrConnect__exrond-connect-btn",active:"dapp-core-component__ActionOrConnect__active"};export{o as a,r as b};
//# sourceMappingURL=chunk-K43BMXNK.js.map
